<div class="portal-page">
  @if (missingParams()) {
  <div class="portal-message portal-message--warn" role="alert">
    <strong>Missing link parameters.</strong>
    Open this page with <code>jobKey</code> and <code>vendorKey</code> query parameters, for
    example:
    <code class="portal-message__example">?jobKey=…&amp;vendorKey=…</code>
  </div>
  } @if (!missingParams()) {
  <div class="work-order-modal">
    <header
      class="modal-header"
      [class.modal-header--logo]="headerVersion() === 'logo'"
      [class.modal-header--label]="headerVersion() === 'label'"
    >
      <div class="brand-wrap">
        @if (headerVersion() === 'logo') {
        <div class="brand brand--logo">
          <img
            class="brand-logo"
            src="https://retailfixitapp.com/logo/RFIdash.png"
            width="180"
            alt="RetailFixit"
          />
        </div>
        } @else {
        <div class="brand brand--label">
          <span class="brand-name">RetailFixit</span>
        </div>
        }
      </div>
      <p class="modal-header-tagline">
        Keep Your
        <b>Work Order Email</b>
        To Manage All Job Steps.
      </p>
    </header>

    <div class="modal-main" [attr.aria-busy]="loading()">
      <div class="modal-main-body" [attr.inert]="loading() ? '' : null">
        @if (!loading() && loadApiMessage(); as apiMsg) {
        <div class="portal-inline-status portal-inline-status--error" role="alert">
          {{ apiMsg }}
        </div>
        } @else if (!loading() && loadError() && !jobData()) {
        <div class="portal-inline-status portal-inline-status--error" role="alert">
          Could not load job details. Check the link or try again later.
        </div>
        } @else if (jobData(); as data) {
        <div class="severity-banner">
          <span class="data-value location-name">PO</span>
          <span class="data-value location-name">{{ data.po }}</span>
          @if (data.jobTypeName) {
          <span class="data-value location-name severity-banner__sep" aria-hidden="true">·</span>
          <span class="data-value location-name">Priority Level:</span>
          <span class="data-value location-name">{{ data.jobTypeName }}</span>
          }
        </div>

        <ng-template #chatPanel>
        <div class="chat-section" aria-label="Job messages">
          <button
            type="button"
            class="chat-accordion-toggle"
            [attr.aria-expanded]="chatOpen()"
            (click)="toggleChatAccordion()"
          >
            <span class="chat-accordion-toggle-label">
              Messages
              @if (chatUnreadCount() > 0) {
              <span class="chat-unread-badge">{{ chatUnreadCount() }}</span>
              }
            </span>
            <span class="chat-accordion-chev" aria-hidden="true">▾</span>
          </button>

          @if (chatOpen()) {
          <div class="chat-body">
            <div class="chat-thread" role="log" aria-live="polite" #chatThreadEl>
              @if (chatLoading() && chatMessages().length === 0) {
              <p class="chat-empty-hint">Loading messages…</p>
              } @else if (chatMessages().length === 0) {
              <p class="chat-empty-hint">No messages yet. Say hello to your RFI contact below.</p>
              } @for (m of chatMessages(); track m.jobChatMessageKey) {
              <div
                class="chat-row"
                [class.chat-row--in]="m.senderType !== ChatSenderVendor"
                [class.chat-row--out]="m.senderType === ChatSenderVendor"
              >
                @if (m.senderType === ChatSenderStaff) {
                <span class="chat-sender-name">{{ m.senderName }}</span>
                } @else if (m.senderType === ChatSenderSystem) {
                <span class="chat-sender-name">System</span>
                }
                <div class="chat-bubble">{{ m.body }}</div>
                <span class="chat-meta">
                  {{ formatChatTime(m.createdUtc) }}
                  @if (m.senderType === ChatSenderVendor) {
                  <svg
                    class="chat-tick"
                    [class.chat-tick--seen]="m.seenByRecipient"
                    [attr.aria-label]="m.seenByRecipient ? 'Seen' : 'Sent'"
                    viewBox="0 0 20 15"
                    width="16"
                    height="12"
                    fill="none"
                  >
                    @if (m.seenByRecipient) {
                    <path d="M1 8.3L4 11.3L10.5 3.7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.5 8.3L10.5 11.3L19 1.7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    } @else {
                    <path d="M4 8.3L8 11.3L16 2.7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    }
                  </svg>
                  }
                </span>
              </div>
              }
            </div>

            @if (chatFeedback(); as fb) {
            <div class="chat-feedback chat-feedback--error" role="alert">{{ fb.text }}</div>
            }

            <div class="chat-composer">
              <input
                type="text"
                class="chat-composer-input"
                [value]="chatComposerText()"
                (input)="onChatComposerInput($event)"
                (keyup.enter)="sendChatMessage()"
                placeholder="Type a message…"
                [disabled]="chatSending()"
              />
              <button
                type="button"
                class="chat-composer-send"
                [disabled]="!canSendChatMessage()"
                (click)="sendChatMessage()"
                aria-label="Send message"
              >
                ➤
              </button>
            </div>
          </div>
          }
        </div>
        </ng-template>

        <div class="modal-body" [class.modal-body--revision]="revisionEditActive()">
          <div class="details-section">
            <!--<div class="data-group">
          <span class="data-label">Job</span>
          <span class="data-value location-name">{{ data.po }}</span>
          <!--@if (data.vendor.address) {
          <span class="data-value data-address">{{ data.vendor.address }}</span>
          } @if (data.vendor.name) {
          <span class="data-value data-address">{{ data.vendor.name }}</span>
          }
        </div>-->

            <!--@if (data.po) {
        <div class="badge-row">
          <span class="data-label stepper-label">PO</span>
          <span
            class="badge"
            [class.badge-emergency]="isEmergencyJobType(data.jobTypeName)"
            [class.badge-emergency-other]="!isEmergencyJobType(data.jobTypeName)"
            >{{ data.po }}</span
          >
        </div>
        }-->
            @if (!revisionEditActive() && !negotiateActive() && descriptionHtml(); as safeDesc) {
            <div class="job-description" [innerHTML]="safeDesc"></div>
            }

            @if (hasEstimates()) {
            @if (editInterruptedNotice(); as interrupted) {
            <div class="estimate-edit-error" role="alert">{{ interrupted }}</div>
            }
            <div class="estimate-grid" role="region" aria-label="Job estimates">
              @for (estimate of estimates(); track estimate.estimateKey) {
              <div class="estimate-card" [class.estimate-card--revision]="cornerPill(estimate)">
                @if (!cornerPill(estimate)) {
                <div class="estimate-card-title">{{ estimateCardTitle(estimate) }}</div>
                }
                @if (estimateOptionTitle(estimate); as optionTitle) {
                <div class="estimate-option-title">{{ optionTitle }}</div>
                }
                @if (estimatePill(estimate); as pill) {
                <span class="estimate-pill" [class.estimate-pill--corner]="cornerPill(estimate)" [attr.data-state]="estimate.stateCode">{{ pill }}</span>
                }
                @if (estimateStateMessage(estimate); as stateMessage) {
                <div class="estimate-state" [class.estimate-state--spotlight]="isRevisionEdit(estimate)"
                  [class.estimate-state--positive]="isNegotiating(estimate)" role="status" [attr.data-state]="estimate.stateCode">
                  {{ stateMessage }}
                  @if (estimate.adminNote && !isNegotiating(estimate)) {
                  <div class="estimate-state-note"><strong>RFI's note:</strong> {{ estimate.adminNote }}</div>
                  }
                </div>
                }
                <div class="estimate-card-header">
                </div>
                <div class="estimate-meta">
                  <span>Updated {{ formatEstimateDate(estimate.estimateUpdatedDate ?? estimate.estimateDate) }}</span>
                  @if (estimate.estimateTotal != null) {
                  <span class="estimate-total">{{ formatEstimateCurrency(estimate.estimateTotal) }}</span>
                  }
                </div>

                @if (editSavedEstimateKey() === estimate.estimateKey) {
                <div class="estimate-saved-confirmation" role="status">Changes saved.</div>
                }

                @if (isEditing(estimate)) {
                <ul class="estimate-line-items estimate-line-items--editing">
                  @for (line of draftFor(estimate.estimateKey); track line.draftId) {
                  <li
                    [class.line-item--marked-deleted]="line.markedDeleted"
                    [class.line-item--invalid]="editShowErrors() && editLineProblems()[line.draftId]"
                  >
                    @if (line.markedDeleted) {
                    <div class="line-item-removed-row">
                      <span class="line-item-removed-name">{{ laborDisplayName(line.itemName, line.isLabor) || '(unnamed line)' }}</span>
                      <button
                        type="button"
                        class="line-item-undo-btn"
                        (click)="undoRemoveLine(line.draftId)"
                      >
                        Undo
                      </button>
                    </div>
                    } @else {
                    @if (line.adminMessage) {
                    <div class="line-item-admin-message" role="note">
                      <strong>RFI's message:</strong> {{ line.adminMessage }}
                    </div>
                    }
                    <div class="line-item-edit-name-row">
                      @if (line.isNew && line.isNewHelper) {
                      <select
                        class="line-item-edit-name-select"
                        [value]="line.newItemTypeKey"
                        (change)="onNewLineTypeChange(line.draftId, $any($event.target).value)"
                      >
                        @for (opt of helperItemTypeOptions; track opt.key) {
                        <option [value]="opt.key">{{ opt.label }}</option>
                        }
                      </select>
                      } @else if (line.isNew && line.isLabor) {
                      <select
                        class="line-item-edit-name-select"
                        [value]="line.newItemTypeKey"
                        (change)="onNewLineTypeChange(line.draftId, $any($event.target).value)"
                      >
                        @for (opt of laborItemTypeOptions; track opt.key) {
                        <option [value]="opt.key">{{ opt.label }}</option>
                        }
                      </select>
                      } @else if (line.isNew && line.isNewTrip) {
                      <select
                        class="line-item-edit-name-select"
                        [value]="line.newItemTypeKey"
                        (change)="onNewLineTypeChange(line.draftId, $any($event.target).value)"
                      >
                        @for (opt of tripItemTypeOptions; track opt.key) {
                        <option [value]="opt.key">{{ opt.label }}</option>
                        }
                      </select>
                      } @else if (line.isNew) {
                      <span class="line-item-edit-name-static">Material</span>
                      } @else if (line.isLabor) {
                      <span class="line-item-edit-name-static">{{ laborDisplayName(line.itemName, line.isLabor) }}</span>
                      } @else {
                      <input
                        type="text"
                        class="line-item-edit-name-input"
                        placeholder="Item name"
                        [value]="line.itemName"
                        (input)="onEditFieldInput(line.draftId, 'itemName', $any($event.target).value)"
                      />
                      }
                      <button
                        type="button"
                        class="line-item-remove-btn"
                        title="Remove line"
                        (click)="removeLine(line.draftId)"
                      >
                        Remove
                      </button>
                    </div>
                    <textarea
                      class="line-item-edit-desc-input"
                      rows="2"
                      placeholder="Description (optional)"
                      [value]="line.description"
                      (input)="onEditFieldInput(line.draftId, 'description', $any($event.target).value)"
                    ></textarea>
                    <div class="line-item-edit-row">
                      <label class="line-item-edit-field">
                        <span>{{ line.isLabor ? 'Hours' : 'Qty' }}</span>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          [value]="line.qty"
                          [disabled]="line.isQuantityLocked"
                          (input)="onEditFieldInput(line.draftId, 'qty', $any($event.target).value)"
                        />
                      </label>
                      <label class="line-item-edit-field">
                        <span>Rate{{ line.isRateLocked ? ' (fixed rate)' : '' }}</span>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          [value]="line.rate"
                          [disabled]="line.isRateLocked"
                          (input)="onEditFieldInput(line.draftId, 'rate', $any($event.target).value)"
                        />
                      </label>
                      @if (line.isLabor) {
                      <label class="line-item-edit-field">
                        <span>Techs</span>
                        <input
                          type="number"
                          min="1"
                          step="1"
                          [value]="line.techOnSite"
                          (input)="onEditFieldInput(line.draftId, 'techOnSite', $any($event.target).value)"
                        />
                      </label>
                      }
                    </div>
                    <div class="line-item-edit-total-row">
                      <span>Line Total</span>
                      <span class="line-item-edit-total-value">
                        @if (line.previousTotal != null) {
                        <span class="line-item-total-previous">{{ formatEstimateCurrency(line.previousTotal) }}</span>
                        }
                        {{ formatEstimateCurrency(lineDraftTotal(line)) }}
                      </span>
                    </div>
                    @if (editShowErrors() && editLineProblems()[line.draftId]; as problem) {
                    <div class="line-item-edit-problem" role="alert">{{ problem }}</div>
                    }
                    }
                  </li>
                  }
                </ul>

                @if (estimate.vendorCanAddLines !== false) {
                <div class="estimate-add-line-row">
                  <button type="button" class="estimate-add-line-btn" (click)="addNewLine('labor', estimate.estimateKey)">
                    + Add Labor Line
                  </button>
                  <button type="button" class="estimate-add-line-btn" (click)="addNewLine('material', estimate.estimateKey)">
                    + Add Material Line
                  </button>
                  @if (canAddTripLine(estimate.estimateKey)) {
                  <button type="button" class="estimate-add-line-btn" (click)="addNewLine('trip', estimate.estimateKey)">
                    + Add Trip Line
                  </button>
                  }
                  <button type="button" class="estimate-add-line-btn" (click)="addNewLine('helper', estimate.estimateKey)">
                    + Add Helper Line
                  </button>
                </div>
                } @else {
                <p class="estimate-no-add-note">RFI is negotiating this estimate: you can lower or remove lines, not add new ones.</p>
                }

                <div class="estimate-edit-total-row">
                  <span>New Total</span>
                  <span class="estimate-edit-total-value">{{ formatEstimateCurrency(editDraftTotalFor(estimate.estimateKey)) }}</span>
                </div>

                @if (!editingGroupKey()) {
                @if (editError(); as err) {
                <div class="estimate-edit-error" role="alert">{{ err }}</div>
                }
                <div class="estimate-edit-actions">
                  @if (!opensStraightIntoEdit(estimate)) {
                  <button
                    type="button"
                    class="btn btn-secondary estimate-edit-btn"
                    [disabled]="editSaving()"
                    (click)="cancelEditEstimate()"
                  >
                    Cancel
                  </button>
                  }
                  <button
                    type="button"
                    class="btn btn-primary estimate-edit-btn"
                    [disabled]="editSaving()"
                    (click)="submitEditEstimate(estimate)"
                  >
                    {{ editSaving() ? 'Saving…' : 'Save Changes' }}
                  </button>
                </div>
                }
                } @else {
                @if (estimate.lineItems.length) {
                <ul class="estimate-line-items">
                  @for (line of estimate.lineItems; track $index) {
                  <li [class.line-item--changed]="line.isAdminUpdate">
                    <div class="line-item-row">
                      <span class="line-item-name">
                        {{ laborDisplayName(line.itemName, line.isLabor) }}
                        @if (line.isAdminUpdate) {
                        <span class="line-item-badge">Updated</span>
                        }
                      </span>
                      <span class="line-item-total">
                        @if (line.isAdminUpdate && line.previousTotal != null) {
                        <span class="line-item-total-previous">{{ formatEstimateCurrency(line.previousTotal) }}</span>
                        }
                        {{ formatEstimateCurrency(line.total) }}
                      </span>
                    </div>
                    @if (line.itemDescription) {
                    <div class="line-item-desc">{{ line.itemDescription }}</div>
                    }
                    @if (lineDiffText(line); as diff) {
                    <div class="line-item-diff">
                      @if (lineDiffParts(line); as parts) { @if (parts.length) { @for (part of parts; track part.label; let last = $last) {
                      {{ part.label }} <s class="line-item-diff-prev">{{ part.prev }}</s> → {{ part.now }}@if (!last) { · }
                      } } @else { {{ diff }} } }
                    </div>
                    }
                    @if (line.adminMessage) {
                    <div class="line-item-admin-message" role="note">
                      <strong>RFI's message:</strong> {{ line.adminMessage }}
                    </div>
                    }
                  </li>
                  }
                </ul>
                }
                <div class="estimate-action-row">
                  @if (canEditEstimate(estimate) && !estimate.isMultiOption) {
                  <button
                    type="button"
                    class="btn btn-secondary estimate-edit-btn"
                    [disabled]="editingEstimateKey() !== null"
                    (click)="startEditEstimate(estimate)"
                  >
                    Edit Estimate
                  </button>
                  }
                  @if (canApproveEstimate(estimate)) {
                  <button
                    type="button"
                    class="btn btn-primary estimate-approve-btn"
                    [disabled]="approvingEstimateKey() === estimate.estimateKey"
                    (click)="approveEstimate(estimate)"
                  >
                    {{ approvingEstimateKey() === estimate.estimateKey ? 'Accepting…' : 'Accept and Agree' }}
                  </button>
                  }
                </div>
                @if (canApproveEstimate(estimate) && approveError()) {
                <p class="estimate-approve-error">{{ approveError() }}</p>
                }
                }
              </div>
              }
            </div>
            @for (group of multiOptionGroups(); track group.groupKey) {
            <div class="estimate-group-actions">
              @if (editSavedEstimateKey() === group.groupKey) {
              <div class="estimate-saved-confirmation" role="status">Changes saved.</div>
              }
              @if (editingGroupKey() === group.groupKey) {
              @if (editError(); as err) {
              <div class="estimate-edit-error" role="alert">{{ err }}</div>
              }
              <div class="estimate-edit-actions">
                @if (!group.options.some(opensStraightIntoEdit)) {
                <button
                  type="button"
                  class="btn btn-secondary estimate-edit-btn"
                  [disabled]="editSaving()"
                  (click)="cancelEditEstimate()"
                >
                  Cancel
                </button>
                }
                <button
                  type="button"
                  class="btn btn-primary estimate-edit-btn"
                  [disabled]="editSaving()"
                  (click)="submitEditGroup(group.groupKey)"
                >
                  {{ editSaving() ? 'Saving…' : 'Save Changes' }}
                </button>
              </div>
              } @else if (group.editable.length) {
              <button
                type="button"
                class="btn btn-secondary estimate-edit-btn"
                [disabled]="editingEstimateKeys().length > 0"
                (click)="startEditGroup(group.groupKey)"
              >
                Edit Estimate
              </button>
              }
            </div>
            }
            } @else {
            <div class="stepper-container">
              <div
                class="stepper-scroll"
                [class.stepper-scroll--complete]="isJobFullyComplete()"
                role="region"
                aria-label="Job status steps"
              >
                <ul class="stepper">
                  @for (step of timeline(); track $index) {
                  <li
                    [class.completed]="!!step.time || !!step.isCompleted"
                    [class.pending]="!step.time && !step.isCompleted"
                    [class.step-current]="isCurrentTimelineIndex($index)"
                  >
                    <div class="step-content">
                      <span class="step-title">{{ formatTimelineTitle(step) }}</span>
                    </div>
                  </li>
                  }
                </ul>
              </div>
            </div>
            }
          </div>

          @if (negotiateActive()) {
          <ng-container *ngTemplateOutlet="chatPanel" />
          } @else if (!revisionEditActive()) {
          <div class="action-section">
            @for (item of visibleActions(); track item.index) {
            <button
              type="button"
              class="btn"
              [class.btn-primary]="actionIsPrimary(item.index, item.action)"
              [class.btn-secondary]="actionIsSecondary(item.index, item.action)"
              [class.btn-danger]="actionIsDecline(item.action)"
              (click)="onActionClick(item.action, data)"
            >
              {{ item.action.text }}
            </button>
            }
          </div>
          }
        </div>

        @if (!negotiateActive()) {
        <ng-container *ngTemplateOutlet="chatPanel" />
        }

        <div
          class="attachments-section"
          aria-label="Job attachments upload"
          [attr.aria-busy]="attachmentUploading()"
          [class.attachments-section--busy]="attachmentUploading()"
        >
          <div class="attachments-section-inner" [attr.inert]="attachmentUploading() ? '' : null">
            <span class="data-label stepper-label">Attachments</span>
            <p class="attachments-hint">Drag and drop images here, or browse to select files.</p>

            <label
              class="attachments-dropzone"
              [class.attachments-dropzone--active]="attachmentDragActive()"
              (dragenter)="onAttachmentDragEnter($event)"
              (dragover)="onAttachmentDragOver($event)"
              (dragleave)="onAttachmentDragLeave($event)"
              (drop)="onAttachmentDrop($event)"
            >
              <input
                #attachmentFileInput
                type="file"
                class="attachments-file-input"
                accept="image/*"
                multiple
                (change)="onAttachmentFileInputChange($event)"
              />
              <span class="attachments-dropzone-text">Drop images here or click to browse</span>
            </label>

            @if (attachmentQueue().length > 0) {
            <ul class="attachments-queue" aria-label="Files to upload">
              @for (file of attachmentQueue(); track $index) {
              <li class="attachments-queue-item">
                <span class="attachments-queue-name">{{ file.name }}</span>
                <span class="attachments-queue-meta">{{ formatAttachmentSize(file.size) }}</span>
                <button
                  type="button"
                  class="attachments-remove"
                  (click)="removeAttachmentAt($index)"
                >
                  Remove
                </button>
              </li>
              }
            </ul>
            }

            <div class="attachments-remarks">
              <label class="data-label stepper-label" for="attachment-remarks"
                >Remarks (optional)</label
              >
              <textarea
                id="attachment-remarks"
                class="attachments-remarks-input"
                rows="2"
                [value]="attachmentRemarks()"
                (input)="onAttachmentRemarksInput($event)"
                placeholder="Add a short note for these files"
              ></textarea>
            </div>

            @if (attachmentFeedback(); as fb) {
            <div
              class="attachments-feedback"
              [class.attachments-feedback--success]="fb.kind === 'success'"
              [class.attachments-feedback--error]="fb.kind === 'error'"
              role="status"
            >
              {{ fb.text }}
            </div>
            }

            <button
              type="button"
              class="btn btn-secondary attachments-upload-btn"
              [class.attachments-upload-btn--ready]="canSendAttachments(data.jobKey)"
              [disabled]="!canSendAttachments(data.jobKey)"
              (click)="uploadAttachments(data.jobKey)"
            >
              @if (attachmentUploading()) {
              <span class="attachments-upload-btn-content">
                <span class="attachments-btn-spinner" aria-hidden="true"></span>
                <span>Uploading…</span>
              </span>
              } @else {
              <span>Send Attachments/Message</span>
              }
            </button>
          </div>
          @if (attachmentUploading()) {
          <div class="attachments-upload-overlay" role="status" aria-live="polite">
            <div class="attachments-upload-spinner" aria-hidden="true"></div>
            <span class="attachments-upload-overlay-text">Uploading attachments…</span>
          </div>
          }
        </div>
        }
      </div>
      @if (loading()) {
      <div class="portal-loading-overlay" role="status" aria-live="polite">
        <div class="portal-loading-spinner" aria-hidden="true"></div>
        <span class="portal-loading-text">Loading job details…</span>
      </div>
      }
    </div>
  </div>
  } @if (appPrompt(); as prompt) {
  <div class="app-prompt-backdrop" (click)="closeAppPrompt()">
    <div
      class="app-prompt"
      role="dialog"
      aria-modal="true"
      aria-labelledby="app-prompt-title"
      (click)="$event.stopPropagation()"
    >
      <h2 id="app-prompt-title" class="app-prompt-title">Download the RFI Vendor App</h2>
      <p class="app-prompt-must">You must download the mobile app for {{ prompt.step }}.</p>
      <p class="app-prompt-sub">
        Install the RetailFixit vendor app on your phone, then use it to
        {{ prompt.step === 'check-in' ? 'check in' : 'check out' }} for this job. Tip: install it before you head to the store so you are not downloading it in the
        parking lot.
      </p>
      @if (appPromptStores().length) {
      <div class="app-prompt-stores">
        @for (store of appPromptStores(); track store.label) {
        <a
          class="btn"
          [class.btn-primary]="store.primary"
          [class.btn-secondary]="!store.primary"
          [href]="store.url"
          target="_blank"
          rel="noopener noreferrer"
          >{{ store.label }}</a
        >
        }
      </div>
      } @else {
      <p class="app-prompt-warn">
        The app download link is not available right now. Please contact RetailFixit and we will
        send it to you.
      </p>
      }
      <p class="app-prompt-note">Already installed? Open the RFI Vendor App and select this job.</p>
      <button type="button" class="btn btn-secondary app-prompt-close" (click)="closeAppPrompt()">
        Close
      </button>
    </div>
  </div>
  }
</div>
